import * as React from "react";
import { Link } from "gatsby"
import * as styles from "~/styles/shared/callouts.module.scss"

const Callouts = ({ callout_arr, wr_class, gaInteract=false }) => {

  const handleClick = () => {
    if (gaInteract) gaInteract('tile click: callout')
  }


  return (
    <div className={[wr_class, styles.callouts, styles.callouts].join(' ')}>
      {callout_arr.map( (callout, index) => {
        return (
          <React.Fragment key={`callout_${index}`}>
            {callout.link ? (
              <Link 
                to={callout.link} 
                className={[styles.callout, styles.callout_link].join(' ')}
                style={{color: `${callout.color ? callout.color : ''}`}}
                onClick={(e) => handleClick()}
              >
                {callout.name}
              </Link>
            ) : (
              <span 
                className={styles.callout} 
                style={{color: `${callout.color ? callout.color : ''}`}}
                >
                {callout.name}
              </span>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Callouts






